;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Anchor } from '@qogita/ui/v2/anchor'
import { Icon } from '@qogita/ui/v2/icon'
import clsx from 'clsx'
import { Suspense } from 'react'
import { ErrorBoundary } from 'src/deprecated/components/shared/ErrorBoundary'

type Props = { className?: string }

function AddPriceListInner() {
  return (
    <div className="flex flex-col items-start gap-6 p-6">
      <div className="flex flex-row items-center gap-2">
        <Icon
          name="heroicons/solid/plus"
          // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
          className="mr-3 size-6 text-gray-900"
        />
        <h4 className="font-figtree flex items-center text-lg leading-7 font-semibold">
          Add price list
        </h4>
      </div>

      <p className="font-light">
        Increase your sales by listing more offers. Qogita now supports multiple
        price lists, each with their own conditions, under a single supplier
        account.
      </p>

      <Anchor
        href="/price-lists/add-price-list/"
        variant="contained"
        // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
        className="flex cursor-pointer font-normal"
      >
        <Icon name="heroicons/solid/plus" className="size-4.5" />
        Add price list
      </Anchor>
    </div>
  )
}

function Fallback() {
  return (
    <div className="flex flex-row items-center p-6">
      <div className="mr-3 rounded-xs bg-gray-200 motion-safe:animate-pulse motion-reduce:opacity-50">
        <Icon name="heroicons/solid/plus" className="invisible size-6" />
      </div>
      <div className="rounded-xs bg-gray-200 motion-safe:animate-pulse motion-reduce:opacity-50">
        <p className="readSales invisible flex items-center text-base font-bold">
          Add price list
        </p>
      </div>
    </div>
  )
}
export function AddPriceList({ className }: Props) {
  return (
    <ErrorBoundary fallback={null}>
      <article
        className={clsx(
          className,
          'relative rounded-lg border border-gray-200 bg-white shadow-xs',
        )}
      >
        <Suspense fallback={<Fallback />}>
          <AddPriceListInner />
        </Suspense>
      </article>
    </ErrorBoundary>
  )
}
